module.exports = __webpack_public_path__ + "img/portfolio-site.f154c046.png";